/** Человекочитаемые подписи статуса спутника — ЕДИНЫЙ источник для фасетов
 *  фильтра и карточки аппарата.
 *
 *  Статус приходит из ``derive_status`` (src/satellites/status.py) и выводится из
 *  каталожного OPS_STATUS_CODE + факта схода с орбиты + свежести TLE. Всё это
 *  говорит ТОЛЬКО о том, летает ли аппарат и следят ли за ним радары. Отказ
 *  полезной нагрузки (AIS-приёмника) каталог не отражает: CelesTrak держит код
 *  ``+`` у кубсата, пока тот не сойдёт с орбиты. Поэтому подписи формулируем
 *  через факт орбиты — слово «активен» обещало бы работающий приёмник.
 */
import { t } from '../i18n'

const STATUS_KEY: Record<string, string> = {
  active: 'satellites.status.active',
  inactive: 'satellites.status.inactive',
  decayed: 'satellites.status.decayed',
  unknown: 'satellites.status.unknown',
}

/** Подпись статуса. Незнакомый код отдаём как есть (фасет не теряет значение),
 *  пустой — прочерком для карточки. */
export function statusLabel(status: string | null | undefined): string {
  if (!status) return '—'
  const key = STATUS_KEY[status]
  return key ? t(key) : status
}
